<template>
  <router-view></router-view>
</template>

<script>
// import * as signalR from "@microsoft/signalr";

// export default {
//   data() {
//     return {
//       connection: null, // Conexión SignalR
//       connection1: null,
//       connectedUsers: [], // Usuarios conectados
//       selectedUser: null, // Usuario seleccionado para chatear
//       messageText: "", // Texto del mensaje
//       messages: [], // Lista de mensajes
//       isTyping: false, // Indicador de escritura
//       typingUser: "", // Usuario que está escribiendo
//     };
//   },
//   methods: {
//     async startConnection() {
//       this.connection = new signalR.HubConnectionBuilder()
//                         .withUrl("https://localhost:7156/chathub", {
//                           accessTokenFactory: () => "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjEiLCJHdWlkIjoiMjYwNDllNjctZDdhNS0xMWVmLTk4OWMtOTQxODgyNmU2Mzc5IiwiVGVuYW50IjoiMSIsIlVzZXJOYW1lIjoibGdlcmFsZG8iLCJFbWFpbCI6ImxnZXJhbGRvQGdjdW5pdC5jb20iLCJQaG90byI6IiIsImV4cCI6MTczNzU2NjQ5NSwiaXNzIjoiaHR0cHM6Ly9ib29zdHNlbGwuZ2N1bml0LmNvbS9pc3MiLCJhdWQiOiJodHRwczovL2Jvb3N0c2VsbC5nY3VuaXQuY29tL2F1ZCJ9.kosbTv5pe2qaL6RQ89vrj_n4VfzVF1DJW1kzAbgk2Qc"
//                         }) 
//                         .build();

//       this.connection.on("ReceiveDirectMessage", message => {
//         this.messages.push(message);
//       });

//       await this.connection
//                 .start()
//                 .then(() => console.log("Conexión establecida"))
//                 .catch((err) => console.error(err));

//       // // Maneja la conexión
//       // this.connection.on("UserConnected", (user) => {
//       //   if (!this.connectedUsers.includes(user)) {
//       //     this.connectedUsers.push(user);
//       //   }
//       // });

//       // this.connection.on("UserDisconnected", (user) => {
//       //   this.connectedUsers = this.connectedUsers.filter((u) => u !== user);
//       // });

//       // this.connection.on("ReceiveDirectMessage", (fromUser, message) => {
//       //   this.messages.push({ from: fromUser, text: message });
//       // });

//       // this.connection.on("UserTyping", (fromUser) => {
//       //   this.isTyping = true;
//       //   this.typingUser = fromUser;

//       //   // Desaparece el indicador después de 2 segundos
//       //   setTimeout(() => {
//       //     this.isTyping = false;
//       //     this.typingUser = "";
//       //   }, 2000);
//       // });

//       // await this.connection
//       //   .start()
//       //   .then(() => console.log("Conexión establecida"))
//       //   .catch((err) => console.error(err));
//     },
//      sendMessage(user, message) {
//         this.connection.invoke("SendDirectMessage", user, message)
//                       .catch(err => console.error("Error al enviar mensaje: ", err));
//     }

//     // selectUser(user) {
//     //   this.selectedUser = user;
//     //   this.messages = []; // Limpia los mensajes al seleccionar un nuevo usuario
//     // },
//     // async sendMessage() {
//     //   if (!this.messageText.trim()) return;

//     //   // Enviar mensaje al servidor
//     //   await this.connection.invoke("SendDirectMessage", this.selectedUser, "User", this.messageText);

//     //   // Agregar mensaje al chat local
//     //   this.messages.push({ from: "Yo", text: this.messageText });
//     //   this.messageText = "";
//     // },
//     // async notifyTyping() {
//     //   if (this.selectedUser) {
//     //       try {
//     //           // Asegúrate de que el usuario y destinatario sean válidos
//     //           await this.connection.invoke("NotifyTyping", this.selectedUser, "User2");
//     //       } catch (err) {
//     //           console.error("Error al notificar escritura:", err);
//     //       }
//     //   }
//     // }
//   },
//   async mounted() {
//     await this.startConnection();
//   },
// };
</script>

<style>
.chat-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 600px;
  margin: auto;
}

.user-list {
  border: 1px solid #ddd;
  padding: 1rem;
}

.user-list ul {
  list-style: none;
  padding: 0;
}

.user-list li {
  padding: 0.5rem;
  cursor: pointer;
}

.user-list li.active {
  background-color: #efefef;
  font-weight: bold;
}

.chat-box {
  border: 1px solid #ddd;
  padding: 1rem;
  height: 300px;
  overflow-y: auto;
}

.message-input {
  display: flex;
  gap: 0.5rem;
}
</style>
